import Axios from "axios";
import { environment } from "src/environment";
import { errorLogger } from "./errorLogger.interceptor";
import { requestLogger } from "./requestLogger.interceptor";
import { responseLogger } from "./responseLogger.interceptor";

// TODO: Change this to use BASE_URL once it's added to the environment
// and send TOS requests using different axios instance

export function createTosHttp(axios = Axios) {
  const http = axios.create({
    baseURL: environment.TOS_API_URL,
  });

  http.interceptors.request.use(requestLogger);
  http.interceptors.response.use(responseLogger, errorLogger);

  return http;
}

export interface HttpStatic extends ReturnType<typeof createTosHttp> {}
